import { render, staticRenderFns } from "./greenshops.vue?vue&type=template&id=2f360be4&scoped=true&"
import script from "./greenshops.vue?vue&type=script&lang=js&"
export * from "./greenshops.vue?vue&type=script&lang=js&"
import style0 from "./greenshops.vue?vue&type=style&index=0&id=2f360be4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f360be4",
  null
  
)

export default component.exports